// lib
import React, { useCallback } from 'react'
import PropTypes from 'prop-types'

// components
import AssetFilesUploader from '@aytm/lib/rfd-ui/components/assets/asset-files-uploader'
import LoaderDots from '@aytm/lib/rfd-ui/components/basic/loader-dots'

// styles
import style from '@aytm/lib/rfd-ui/styles/assets/upload-assets-button.module.scss'

UploadAssetsButton.propTypes = {
  type: PropTypes.oneOf(['image', 'video']),
  text: PropTypes.string,
  renderProgressText: PropTypes.func,
  maxItems: PropTypes.number,
  multiple: PropTypes.bool,
  withOriginal: PropTypes.bool,
  withErrors: PropTypes.bool,
  onFilesUploaded: PropTypes.func.isRequired,
  onFilesUpload: PropTypes.func
}

export default function UploadAssetsButton(props) {
  const {
    text,
    type,
    renderProgressText,
    multiple = false,
    maxItems,
    withOriginal,
    withErrors = false,
    onFilesUpload,
    onFilesUploaded
  } = props

  const renderButton = useCallback(
    ({ dragOver = false, progress, uploading } = {}) => (
      <div className={`${style.component}${dragOver ? ' ' + style.dragOver : ''}`}>
        {uploading && progress ? (
          <ProgressPanel progress={progress} renderProgressText={renderProgressText} />
        ) : (
          <DropPanel type={type} text={text || ''} />
        )}
      </div>
    ),
    [type, text, renderProgressText]
  )

  return (
    <AssetFilesUploader
      type={type}
      maxItems={maxItems}
      multiple={multiple}
      watchProgress={true}
      withErrors={withErrors}
      withOriginal={withOriginal}
      onFilesUploaded={onFilesUploaded}
      onFilesUpload={onFilesUpload}
      content={renderButton}
    />
  )
}

DropPanel.propTypes = {
  type: PropTypes.oneOf(['image', 'video']),
  text: PropTypes.string.isRequired
}

export function DropPanel(props) {
  const { type, text } = props
  return (
    <div className={style.inner}>
      <div className={style.label}>
        <i className={`${style.icon} ${'video' === type ? style['icon-video'] : style['icon-image']}`} />
        <div className={style.text}>{text || ''}</div>
      </div>
    </div>
  )
}

ProgressPanel.propTypes = {
  renderProgressText: PropTypes.func,
  progress: PropTypes.object.isRequired
}
export function ProgressPanel(props) {
  const { progress = {}, renderProgressText } = props
  const { percents = 0, loadedFiles = 0, totalFiles = 1 } = progress || {}
  return (
    <div className={style.inner}>
      <div className={style.label}>
        <div className={style.uploadingPercents}>
          <LoaderDots dotSize={7} dots={3} height={15} /> {100 > percents ? `${percents}%` : ''}
        </div>
        {'function' === typeof renderProgressText ? (
          <div className={style.uploadingFiles}>{renderProgressText({ loadedFiles, totalFiles })}</div>
        ) : null}
      </div>
    </div>
  )
}
